import axios from 'axios';

const getProblemDetail = (problemId) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/api/crop/problemDetail/${problemId}`)
    .then(res => res)
    .catch(err => err);
};

export default getProblemDetail;
